<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content>
    <mat-form-field *ngIf="positiveText=='Login'">
        <mat-label for="password">Password</mat-label>
        <input matInput type="password" name="password" [(ngModel)]="passowrdModel" />
        <div *ngIf="response==false" class="help-block">Invalid Password</div>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="text-right">
        <button mat-button class="text-white btn btn-success" (click)="login();">{{positiveText}}</button>
        <button mat-button class="text-white btn btn-danger" mat-dialog-close cdkFocusInitial>Cancel</button>
    </div>
</mat-dialog-actions>